/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

const APIFactory = require('gemini/lib/@waca/dashboard-common/dist/core/APIFactory');
const PropertiesProviderAPI = require('gemini/lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI');

export const PROFILE_PROPERTIES = {
	types: [
		'Bar',
		'Column',
		'DualAxis',	// Line Column
		'Marimekko',
		'Dial',	// Radial
		'StackedBar',
		'StackedColumn',
		'Pie',
		'Area',
		'Line',
		'Point',
		'KPI',
		'Crosstab',
		'DriverAnalysis',
		'List'
	],
	properties: [
		'area.interpolate',
		'data.handling',
		'valueLabels.visible',
		'column.valueLabels.visible',
		'lineWithPoints.valueLabels.visible',
		'valueAxis.zeroOrigin',
		'valueLabels.format',
		'label.percentage',
		'stacked.percent',
		'showItemLabel',
		'fixedRowHeight',
		'fixedColumnWidth'
	]
};

const KPI_PROPERTIES = [
	'conditionalFormattingEnabled',
	'rangeScale',
	'numberOfRanges'
];

class LayoutPropertiesProvider {
	constructor(options) {
		this.dashboardApi = options.dashboardAPI;
		this.content = options.content;
		this.stringResources = this.dashboardApi.getFeature('.StringResources');
		this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
		this.content.getFeature('Properties').registerProvider(this.getAPI());
	}

	getAPI() {
		return this._api;
	}

	reset() {}

	getPropertyLayoutList() {
		const propertyLayoutList = [{
			id: 'visualization',
			type: 'Group',
			profile: ['explore']
		}, {
			id: 'chart',
			type: 'Section',
			profile: ['explore']
		}];
		if (this._getVisType() === 'KPI' && !this._isNewKpiConditionalFormatFeature()) {
			const KPIPropertyLayoutList = KPI_PROPERTIES.map(property => {
				return {
					id: property,
					profile: ['explore']
				};
			});
			propertyLayoutList.push({
				id: 'conditionalFormatting',
				profile: ['explore'],
				editor: {
					uiControl: {
						addButton: false
					}
				}
			});
			propertyLayoutList.push(...[{
				id: 'color',
				type: 'Section',
				profile: ['explore']
			}, {
				id: 'range',
				type: 'Section',
				profile: ['explore']
			}]);
			propertyLayoutList.push(...KPIPropertyLayoutList);
		}
		return propertyLayoutList;
	}

	getPropertyList() {
		// To remove show labels for KPI, all other KPI properties are in the PropertyLayoutList
		if (this._getVisType() === 'KPI') {
			return [];
		}

		const propertyList = PROFILE_PROPERTIES.properties.map(propertyName => ({
			id: propertyName,
			profile: ['explore']
		}));

		return propertyList;
	}

	_getVisType() {
		return this.content.getFeature('Visualization').getType();
	}

	_isNewKpiConditionalFormatFeature () {
		return !(this.dashboardApi.getGlassCoreSvc('.FeatureChecker').checkValue('dashboard', 'condFormat', 'disabled'));
	}
}

export default LayoutPropertiesProvider;



// WEBPACK FOOTER //
// ./src/js/features/properties/ExploreLayoutPropertiesProvider.js